module.exports = __webpack_public_path__ + "static/media/facebook~HeMFJrik.ce0c8188.svg";